import React from 'react';
import GeneralRateRow from '../../../../components/pricing/general-rate-row';
import { getFormattedExtensionRates } from '../../../../shared/utility/pricing-utility';

function AdditionalCharges(props) {
    const { rentalExtension } = props;
    const formattedRates = getFormattedExtensionRates(rentalExtension?.rates || []);
    return (
        <div className='extend-pricing-container'>
            {
                formattedRates?.map((data) => {
                    return <GeneralRateRow
                        key={data?.title}
                        title={data?.title}
                        total={data?.subtotal}
                    />
                })
            }
            {
                rentalExtension?.fees?.map((data) => {
                    return <GeneralRateRow
                        key={data?.feeDesc}
                        title={data?.feeDesc}
                        total={data?.fee}
                    />
                })
            }

            <GeneralRateRow
                title="Total"
                total={rentalExtension?.totalAuth && rentalExtension?.totalAuth}
                contClasses="card-value-container general-total bg-input"
            />
        </div>
    )
}

export default AdditionalCharges